var path = 'app/components/loading-icon/template.html';
var html = "<div class='uil-ripple-css' style='transform:scale(0.51);'><div></div><div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;